import firebase from 'firebase';
import _ from 'lodash';
import dayjs from "dayjs";
import {filterJobs} from "../utils/filterJobs";

export const getProjectByPlan = (projectID, planID, versionID) => {
  if (planID) {
    return myFirestore
      .collection('projects')
      .doc(projectID)
      .collection('plan')
      .doc(planID)
  }

  if (versionID) {
    return myFirestore
      .collection('projects')
      .doc(projectID)
      .collection('versions')
      .doc(versionID)
  }

  return myFirestore
    .collection('projects')
    .doc(projectID)
}

export const getPlans = async (id) => {
  const plans = await myFirestore
    .collection('projects')
    .doc(id)
    .collection('plan')
    .get();

  const result = [];

  plans.forEach((subDoc) => {
    const data = subDoc.data();
    result.push({
      ...data,
      id: subDoc.id || null,
    });
  });

  return [..._.orderBy(result, 'name', ['asc'])];
};


export const checkPlan = async (plan, projectID) => {
  if (!plan) return false


  const plans = await getPlans(projectID);
  const find = plans.find((p) => p.id === plan.id);

  if (!find) {
    localStorage.removeItem('plan')

    return false
  }

  return true
}



export const calculateProfTechByJobs = async ({
                                                planID,
                                                projectID,
                                                date,
                                                profTechId,
                                                type = 'prof',
                                                turn,
                                                objectID = 'all',
                                                permission
                                              }) => {
  const volumes_type = type.toLowerCase()
  const datetime = dayjs(date).format('DD.MM.YYYY');

  let jobsResponse = null;

  if (!profTechId) {
    return null
  }

  try {
    jobsResponse = await getProjectByPlan(projectID, planID).collection('jobs')
      .where('type', '==', 'JOB')
      .where(`ids_${volumes_type}`, 'array-contains-any', [profTechId])
      .get();

    let total = 0
    const jobs = []
    jobsResponse.forEach((subDoc) => {
      jobs.push({
        ...subDoc.data(),
        id: subDoc.id
      });
    });

    const filteredJobs = filterJobs(jobs, permission, objectID);

    filteredJobs.forEach((data) => {

      if (!data.objects.includes(objectID || 'all')) {
        return
      }

      const job = data[`volumes_${volumes_type}`].filter(({id}) => id === profTechId)

      job.forEach((j) => total += Number(j.volumes[turn - 1][datetime] || 0))
    });

    return total
  } catch (e) {
    console.log(e)
    return 0
  }
}



// WEBPACK FOOTER //
// ./src/firestore/plan.js